import React from 'react'
import { Grid } from '@material-ui/core'
import styles from './styles'
import withStyles from '@material-ui/core/styles/withStyles'
import yesIcon from '../../images/YES.svg'
import noIcon from '../../images/NO.svg'

const TutorialDroppable = (props) => {

  const {
    classes,
    iconTitle,
  } = props

  return (
    <Grid container justify='center' alignItems='center' className={classes.droppableTutorial}>
      <Grid>
        <img src={iconTitle === 'yes' ? yesIcon : noIcon} className={classes.icon} />
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(TutorialDroppable)
